/**
 * This file contains all the success and error messages used in the application.
 * Centralizing these messages ensures consistency across all pages and components.
 */

export const SUCCESS_MESSAGES = {
  DOCUMENT_UPLOADED: "Document has been uploaded successfully.",
  ACCOUNT_DELETED: "Your account has been deleted successfully.",
  PROFILE_UPDATED: "Profile information updated successfully.",
  REGISTRATION_COMPLETED: "Your registration has been completed successfully.",
  OTP_SENT: "One-Time Password (OTP) has been sent successfully.",
  PASSWORD_CHANGED: "Your password has been changed successfully.",
  WAITING_FOR_APPROVAL: "Your request is currently awaiting administrative approval.",
  CAR_ADDED: "Vehicle has been added to your inventory successfully.",
  ORDER_ACCEPTED: "Order has been accepted successfully.",
  ORDER_DELIVERED: "Order marked as delivered successfully.",
  ORDER_DECLINED: "Order has been declined.",
  BOOKING_SUCCESS: "Your booking has been confirmed successfully.",
  DOCUMENTS_UPLOADED_CAPS: "Documents have been uploaded successfully.",
  OTP_VERIFIED: "OTP verified successfully.",
  OTP_RESENT: "OTP has been resent to your registered contact.",
  UPLOAD_SUCCESS: "File uploaded successfully.",
  SERVICE_UPDATED: "Service details updated successfully.",
};

export const ERROR_MESSAGES = {
  DOCUMENT_UPLOAD_FAILED: "We encountered an error while uploading the document. Please try again.",
  ACCOUNT_DELETE_FAILED: "Unable to delete account at this moment. Please contact support if the issue persists.",
  MANDATORY_FIELDS: "Please complete all required fields before proceeding.",
  OTP_SEND_FAILED: "Failed to send OTP. Please check your network connection and try again.",
  DEFAULT_ERROR: "Something went wrong. Please try again later.",
  TRN_INVALID: "The TRN number entered is invalid. Please double-check and try again.",
  IBAN_INVALID: "The IBAN number entered is invalid. Please provide a valid IBAN.",
  FILE_REQUIRED: "This field is required.",
  FETCH_FAILED: "We were unable to retrieve the requested data. Please refresh the page.",
  UPDATE_FAILED: "Failed to update your details. Please try again.",
  IMAGE_ONLY: "Only image files are allowed. Please select a valid image (JPG, PNG, etc.).",
  OTP_VERIFY_FAILED: "The OTP entered is incorrect. Please try again.",
  OTP_RESEND_FAILED: "Unable to resend OTP at this time. Please try again in a few moments.",
  FAILED_TRY_AGAIN: "Operation failed. Please try again.",
  UPLOAD_FAILED: "Upload failed. Please check the file size or format and try again.",
  ACCESS_DENIED: "You do not have permission to access this section.",
  INVALID_CREDENTIALS: "The username or password you entered is incorrect.",
  NOT_REGISTERED: "This account is not yet registered in our system.",
  SELECT_SERVICE_LOCATION: "Please select both a service type and a valid location.",
  ORDER_ID_MISSING: "Request could not be processed because the Order ID is missing.",
  SERVICE_UPDATE_FAILED: "Unable to update service details. Please try again.",
  CONFIRM_SERVICE_UPDATE: "Are you sure you want to update the service details?",
};
